import React from 'react';
import styled from 'styled-components';
import useTranslate from '../../../hooks/useTranslate';
import Button from '../Button';
import Modal from '../Modal';

const OrderSuccessModal = ({ hideSuccessModal }) => {
  const { t } = useTranslate();
  return (
    <Modal onClickOverlay={hideSuccessModal}>
      <Title>{t('requestAccepted')}</Title>
      <Text>{t('requestAcceptedDescription')}</Text>
      <Button type="button" onClick={hideSuccessModal}>
        {t('ok')}
      </Button>
    </Modal>
  );
};

export default OrderSuccessModal;

const Title = styled.div`
  margin: 7px 0 16px;
  font-size: 20px;
  line-height: 26px;
  text-align: center;
`;

const Text = styled.div`
  margin-bottom: 24px;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  color: rgba(0, 0, 0, 0.64);
`;
